module.exports = __webpack_public_path__ + "img/arbor_b2.ed88a5be.jpg";